<div class="energy-container" *ngIf="character">
  <div class="progress-bar energy">
    <div class="icon energy"></div>
    <div class="inside-container energy">
      <div class="level-number">{{ character.energy.quantity }}</div>
      <div class="level-number result" *ngIf="result">
        {{ "+ " + result.quantity }}
      </div>
      <div class="scale-container energy">
        <div
          class="scale energy"
          style.width="{{ character.energy.quantityInPercent }}%"
        ></div>
        <div
          class="scale preview"
          *ngIf="result"
          style.width="{{ result.quantityInPercent }}%"
        ></div>
      </div>
    </div>
  </div>
</div>
